import { Button } from "@/components/ui/button";
import { useCheckIsProjectLocked } from "@/modules/projects/hooks/useCheckIsProjectLocked";
import { UserMinus } from "lucide-react";
import { ComponentProps, memo } from "react";
import { useTranslation } from "react-i18next";
import { useRowSelectionCount } from "@/components/data-table/hooks/useRowSelectionCount";
import { useProjectManagersRemoveUsersContext } from "./ProjectManagersRemoveUsersContext";

interface RemoveUsersButtonProps {
  variant?: ComponentProps<typeof Button>["variant"];
}

const ProjectManagersRemoveUsersButtonComponent = ({
  variant = "outline",
}: RemoveUsersButtonProps) => {
  const { t } = useTranslation();
  const isProjectLocked = useCheckIsProjectLocked();
  const selectedCount = useRowSelectionCount();
  const { handleRemove, isSubmitting } = useProjectManagersRemoveUsersContext();

  return (
    <Button
      className="gap-2"
      variant={variant}
      size="sm"
      disabled={selectedCount === 0 || isSubmitting || isProjectLocked}
      type="button"
      onClick={handleRemove}
    >
      <UserMinus className="w-5 h-5 mr-1" />
      {t("projects.managers.removeUsers.button")}
      {selectedCount > 0 && ` (${selectedCount})`}
    </Button>
  );
};

export const ProjectManagersRemoveUsersButton = memo(
  ProjectManagersRemoveUsersButtonComponent,
);
